import Vue from 'vue'

const requireContext = require.context('./', true, /.*\.vue$/)

Vue.config.warnHandler = function (msg, vm, trace) {
    // @Note: Fix vue warning about custom elements with HTML reserved names
    if (!msg.includes('Do not use built-in or reserved HTML elements as component id'))
    {
        console.error(("[Vue warn]: " + msg + trace))
    }
}

requireContext.keys().forEach(file => {
    const comp = requireContext(file).default
    if (comp && comp.name)
        Vue.component(`${process.env.VUE_APP_COMPONENT_PREFIX}-${comp.name}`, comp)
})
